import { AbilitySubject, every, not } from "@cdv/jazz-auth";
import { User } from "../../api";
import { isAppuser } from "../utils";

export default function defineAudioAbility(can: AbilitySubject<User>): void {
  can("read");
  can(["update", "create"], not(isAppuser));
}
